import { ReactNode } from 'react';
import { Box, Container, styled } from '@mui/material';
import classnames from 'classnames';

export type BlockContainerProps = {
  children?: ReactNode;
  fullscreen?: boolean;
  noAddedPadding?: boolean;
};

/**
 * Block container - fullscreen or wrapped in container
 */
export const BlockContainer = ({ fullscreen, children, noAddedPadding }: BlockContainerProps) => {
  const containerClassName = classnames('block-container with-padding', {
    'no-added-padding': noAddedPadding,
  });
  return fullscreen ? (
    <Box className='block-container fullscreen'>{children}</Box>
  ) : (
    <Container className={containerClassName}>{children}</Container>
  );
};

export type BlockCardProps = {
  children?: ReactNode;
  fullscreen?: boolean;
};

const StyledBoxCard = styled(Box)`
  background: #fff;
  border-radius: 4px;
  padding: 16px;
`;

export const BlockCard = ({ children }: BlockContainerProps) => {
  return <StyledBoxCard>{children}</StyledBoxCard>;
};
